import { createElement } from "react";
import React from "react";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { tokens, Image, Button } from "@fluentui/react-components";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { startAsPromise } from "./fable_modules/fable-library-js.4.24.0/Async.js";
import { Browser_Types_File__File_ReadAsByteArray } from "./fable_modules/Fable.Remoting.Client.7.35.0/Extensions.fs.js";
import { S3 } from "./ApiClient.jsx";
import { S3UploadFile } from "./Shared/SharedModels.jsx";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { option_type, union_type, int32_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { ofArray, tail, head, isEmpty } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { Route_$007CInt$007C_$007C } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { useCtx } from "./Context.jsx";
import { useFeliz_React__React_useResponsive_Static_Z434A9929 } from "./fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { notFoundView, unauthorizedView } from "./Helpers.jsx";
import { createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { CoursePage } from "./Course.jsx";
import { View } from "./Event/EventAttendees.jsx";
import { View as View_1 } from "./Event/ListEvents.jsx";
import { View as View_2 } from "./Event/EventView.jsx";
import { TrackView } from "./Track/TrackView.jsx";
import { TrackBuilder } from "./Track/TrackBuilder.jsx";
import { unwrap } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { EditCourseView } from "./Track/EditCourse.jsx";
import { ListTracks } from "./Track/ListTracks.jsx";
import { AboutUser } from "./UserProfile.jsx";
import { WorkplaceTable } from "./Workplaces.jsx";
import { RegionsView } from "./Regions.jsx";
import { View as View_3 } from "./ApproveUsers.jsx";
import { View as View_4 } from "./Home.jsx";

export function S3UploadTester() {
    const patternInput = reactApi.useState(undefined);
    const patternInput_1 = reactApi.useState(undefined);
    const children = toList(delay(() => append(singleton(createElement("input", {
        type: "file",
        onChange: (ev) => {
            const files = ev.target.files;
            if (!(files == null) && (files.length > 0)) {
                patternInput[1](files.item(0));
            }
        },
    })), delay(() => {
        let el;
        const matchValue = patternInput[0];
        if (matchValue != null) {
            const f_1 = matchValue;
            return append(singleton((el = Button, createElement(el, {
                children: "Upload",
                onClick: (_arg) => {
                    const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (startAsPromise(Browser_Types_File__File_ReadAsByteArray(f_1)).then((_arg_1) => {
                        let MimeType;
                        const pr = startAsPromise(S3.UploadFile((MimeType = f_1.type, new S3UploadFile(f_1.name, MimeType, _arg_1))));
                        void (pr.then((res) => {
                            if (res.tag === 0) {
                                patternInput_1[1](res.fields[0]);
                            }
                        }));
                        return Promise.resolve();
                    }))));
                    void pr_1;
                },
            }))), delay(() => {
                let el_2;
                const matchValue_1 = patternInput_1[0];
                return (matchValue_1 != null) ? singleton((el_2 = Image, createElement(el_2, {
                    src: matchValue_1,
                }))) : singleton(defaultOf());
            }));
        }
        else {
            return singleton(defaultOf());
        }
    }))));
    return createElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

export class EventPage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["View", "Attendees", "List"];
    }
}

export function EventPage_$reflection() {
    return union_type("Routes.EventPage", [], EventPage, () => [[["Item", int32_type]], [["Item", int32_type]], []]);
}

export class AdminPage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Workplaces", "Regions", "ApproveUsers"];
    }
}

export function AdminPage_$reflection() {
    return union_type("Routes.AdminPage", [], AdminPage, () => [[], [], []]);
}

export class TrackPage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["List", "View", "Builder", "CourseTemplates"];
    }
}

export function TrackPage_$reflection() {
    return union_type("Routes.TrackPage", [], TrackPage, () => [[], [["Item", int32_type]], [["Item", option_type(int32_type)]], []]);
}

export class Page extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Home", "S3Test", "CourseTypes", "Event", "Track", "UserProfile", "Admin", "NotFound"];
    }
}

export function Page_$reflection() {
    return union_type("Routes.Page", [], Page, () => [[], [], [], [["Item", EventPage_$reflection()]], [["Item", TrackPage_$reflection()]], [["Item", int32_type]], [["Item", AdminPage_$reflection()]], []]);
}

function eventRouter(url) {
    let matchResult, eventId;
    if (!isEmpty(url)) {
        const activePatternResult = Route_$007CInt$007C_$007C(head(url));
        if (activePatternResult != null) {
            if (isEmpty(tail(url))) {
                matchResult = 1;
                eventId = activePatternResult;
            }
            else {
                matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return new Page(3, [new EventPage(2, [])]);
        case 1:
            return new Page(3, [new EventPage(0, [eventId])]);
        default: {
            let matchResult_1, eventId_1;
            if (!isEmpty(url)) {
                const activePatternResult_1 = Route_$007CInt$007C_$007C(head(url));
                if (activePatternResult_1 != null) {
                    if (!isEmpty(tail(url))) {
                        if (head(tail(url)) === "deltakerliste") {
                            if (isEmpty(tail(tail(url)))) {
                                matchResult_1 = 0;
                                eventId_1 = activePatternResult_1;
                            }
                            else {
                                matchResult_1 = 1;
                            }
                        }
                        else {
                            matchResult_1 = 1;
                        }
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return new Page(3, [new EventPage(1, [eventId_1])]);
                default:
                    return new Page(7, []);
            }
        }
    }
}

function trackRouter(url) {
    let matchResult, id;
    if (!isEmpty(url)) {
        const activePatternResult = Route_$007CInt$007C_$007C(head(url));
        if (activePatternResult != null) {
            if (isEmpty(tail(url))) {
                matchResult = 1;
                id = activePatternResult;
            }
            else {
                matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return new Page(4, [new TrackPage(0, [])]);
        case 1:
            return new Page(4, [new TrackPage(1, [id])]);
        default: {
            let matchResult_1, id_1;
            if (!isEmpty(url)) {
                if (head(url) === "bygger") {
                    if (!isEmpty(tail(url))) {
                        const activePatternResult_1 = Route_$007CInt$007C_$007C(head(tail(url)));
                        if (activePatternResult_1 != null) {
                            if (isEmpty(tail(tail(url)))) {
                                matchResult_1 = 1;
                                id_1 = activePatternResult_1;
                            }
                            else {
                                matchResult_1 = 2;
                            }
                        }
                        else {
                            matchResult_1 = 2;
                        }
                    }
                    else {
                        matchResult_1 = 0;
                    }
                }
                else {
                    matchResult_1 = 2;
                }
            }
            else {
                matchResult_1 = 2;
            }
            switch (matchResult_1) {
                case 0:
                    return new Page(4, [new TrackPage(2, [undefined])]);
                case 1:
                    return new Page(4, [new TrackPage(2, [id_1])]);
                default: {
                    let matchResult_2;
                    if (!isEmpty(url)) {
                        if (head(url) === "bygger") {
                            if (!isEmpty(tail(url))) {
                                if (head(tail(url)) === "kursmal") {
                                    if (isEmpty(tail(tail(url)))) {
                                        matchResult_2 = 0;
                                    }
                                    else {
                                        matchResult_2 = 1;
                                    }
                                }
                                else {
                                    matchResult_2 = 1;
                                }
                            }
                            else {
                                matchResult_2 = 1;
                            }
                        }
                        else {
                            matchResult_2 = 1;
                        }
                    }
                    else {
                        matchResult_2 = 1;
                    }
                    switch (matchResult_2) {
                        case 0:
                            return new Page(4, [new TrackPage(3, [])]);
                        default:
                            return new Page(7, []);
                    }
                }
            }
        }
    }
}

function adminRouter(url) {
    let matchResult;
    if (!isEmpty(url)) {
        switch (head(url)) {
            case "bruker": {
                if (!isEmpty(tail(url))) {
                    if (head(tail(url)) === "godkjenn") {
                        if (isEmpty(tail(tail(url)))) {
                            matchResult = 0;
                        }
                        else {
                            matchResult = 3;
                        }
                    }
                    else {
                        matchResult = 3;
                    }
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            case "arbeidsplasser": {
                if (isEmpty(tail(url))) {
                    matchResult = 1;
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            case "regioner": {
                if (isEmpty(tail(url))) {
                    matchResult = 2;
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            default:
                matchResult = 3;
        }
    }
    else {
        matchResult = 3;
    }
    switch (matchResult) {
        case 0:
            return new Page(6, [new AdminPage(2, [])]);
        case 1:
            return new Page(6, [new AdminPage(0, [])]);
        case 2:
            return new Page(6, [new AdminPage(1, [])]);
        default:
            return new Page(7, []);
    }
}

export function pageFromUrl(url) {
    let matchResult, rest, uId;
    if (!isEmpty(url)) {
        switch (head(url)) {
            case "s3": {
                if (isEmpty(tail(url))) {
                    matchResult = 1;
                }
                else {
                    matchResult = 5;
                }
                break;
            }
            case "kurstype": {
                if (isEmpty(tail(url))) {
                    matchResult = 2;
                }
                else {
                    matchResult = 5;
                }
                break;
            }
            case "kurs": {
                matchResult = 3;
                rest = tail(url);
                break;
            }
            case "bruker": {
                if (!isEmpty(tail(url))) {
                    const activePatternResult = Route_$007CInt$007C_$007C(head(tail(url)));
                    if (activePatternResult != null) {
                        if (isEmpty(tail(tail(url)))) {
                            matchResult = 4;
                            uId = activePatternResult;
                        }
                        else {
                            matchResult = 5;
                        }
                    }
                    else {
                        matchResult = 5;
                    }
                }
                else {
                    matchResult = 5;
                }
                break;
            }
            default:
                matchResult = 5;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return new Page(0, []);
        case 1:
            return new Page(1, []);
        case 2:
            return new Page(2, []);
        case 3:
            return eventRouter(rest);
        case 4:
            return new Page(5, [uId]);
        default: {
            let matchResult_1, rest_1, rest_2;
            if (!isEmpty(url)) {
                switch (head(url)) {
                    case "kurslop": {
                        matchResult_1 = 0;
                        rest_1 = tail(url);
                        break;
                    }
                    case "admin": {
                        matchResult_1 = 1;
                        rest_2 = tail(url);
                        break;
                    }
                    default:
                        matchResult_1 = 2;
                }
            }
            else {
                matchResult_1 = 2;
            }
            switch (matchResult_1) {
                case 0:
                    return trackRouter(rest_1);
                case 1:
                    return adminRouter(rest_2);
                default:
                    return new Page(7, []);
            }
        }
    }
}

export function CurrentPage(currentPageInputProps) {
    let elems_2, elems_1, elems;
    const currentPage = currentPageInputProps.currentPage;
    const patternInput = useCtx();
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const requireAdmin = (page) => {
        if (patternInput[0].User.IsAdmin) {
            return page();
        }
        else {
            return unauthorizedView();
        }
    };
    return createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["width", 100 + "%"]), delay(() => append(singleton(["height", ("calc(" + "100vh - 60px") + ")"]), delay(() => append(singleton(["display", "flex"]), delay(() => {
        let matchValue;
        return append((matchValue = currentPage, (matchValue.tag === 4) ? ((matchValue.fields[0].tag === 2) ? singleton(["justifyContent", "left"]) : singleton(["justifyContent", "center"])) : singleton(["justifyContent", "center"])), delay(() => append(singleton(["backgroundColor", tokens.colorNeutralBackground2]), delay(() => singleton(["overflow", "auto"])))));
    })))))))))], (elems_2 = [createElement("div", createObj(ofArray([["style", {
        maxWidth: 1000,
        flexGrow: 1,
    }], (elems_1 = [createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => ((screenSize.tag === 0) ? singleton(["padding", 1 + "rem"]) : ((screenSize.tag === 1) ? singleton(["padding", 1 + "rem"]) : singleton(["padding", 2 + "rem"]))))))], (elems = toList(delay(() => ((currentPage.tag === 1) ? singleton(createElement(S3UploadTester, null)) : ((currentPage.tag === 2) ? singleton(createElement(CoursePage, null)) : ((currentPage.tag === 3) ? ((currentPage.fields[0].tag === 1) ? singleton(createElement(View, {
        eventId: currentPage.fields[0].fields[0],
    })) : ((currentPage.fields[0].tag === 2) ? singleton(createElement(View_1, null)) : singleton(createElement(View_2, {
        eventId: currentPage.fields[0].fields[0],
    })))) : ((currentPage.tag === 4) ? ((currentPage.fields[0].tag === 1) ? singleton(createElement(TrackView, {
        trackId: currentPage.fields[0].fields[0],
    })) : ((currentPage.fields[0].tag === 2) ? singleton(createElement(TrackBuilder, {
        trackId: unwrap(currentPage.fields[0].fields[0]),
    })) : ((currentPage.fields[0].tag === 3) ? singleton(createElement(EditCourseView, null)) : singleton(createElement(ListTracks, null))))) : ((currentPage.tag === 5) ? singleton(createElement(AboutUser, {
        userId: currentPage.fields[0],
    })) : ((currentPage.tag === 6) ? ((currentPage.fields[0].tag === 0) ? singleton(requireAdmin(() => createElement(WorkplaceTable, null))) : ((currentPage.fields[0].tag === 1) ? singleton(requireAdmin(() => createElement(RegionsView, null))) : singleton(requireAdmin(() => createElement(View_3, null))))) : ((currentPage.tag === 7) ? singleton(notFoundView()) : singleton(createElement(View_4, null))))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

//# sourceMappingURL=Routes.jsx.map
